import { Box, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { useMedReqsQuery } from '@/services/med-requests'
import { columns, MED_REQ_FILTER_ONLY_COLUMNS } from './columns'
import DataGridTable, { type FilterValueOptions } from '@/components/shared/DataGridTable'
import { MED_REQUEST_STATUSES } from '@/constants/statuses'

const FILTER_VALUE_OPTIONS: FilterValueOptions = {
  orderItemStatus: MED_REQUEST_STATUSES.filter(status => status.value !== 'wc-item-created')
}

export default function MedRequestsPage() {
  const navigate = useNavigate()
  const { medReqs, count, isLoading, isFetching, dataGridConfig } = useMedReqsQuery({ tableId: 'med-requests' })

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Typography variant='pageTitle' component='h1' sx={{ fontSize: '24px' }}>
        Medication Requests
      </Typography>

      <DataGridTable
        {...dataGridConfig}
        rows={medReqs}
        columns={columns}
        rowCount={count}
        loading={isLoading || isFetching}
        filterOnlyColumns={MED_REQ_FILTER_ONLY_COLUMNS}
        filterValueOptions={FILTER_VALUE_OPTIONS}
        showQuickFilter={false}
        onRowClick={params =>
          navigate(`/med-requests/${params.row.hash}`, {
            state: { backLabel: 'Back to Medication Requests', fallbackPath: '/med-requests' }
          })
        }
      />
    </Box>
  )
}
